import surveyAPI from 'api/base';

import { GetPayment } from './types';

export const getPayment: GetPayment = (uuid, paymentId) => {
  return surveyAPI.get(`/payments/${uuid}?payment_id=${paymentId}`);
};
